import { Component, Input, OnInit, forwardRef, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { PopoverDirective } from 'ngx-bootstrap/popover';

@Component({
    standalone: false,
    selector: 'res-custom-date-time-picker',
    templateUrl: './custom-date-time-picker.component.html',
    styleUrls: ['./custom-date-time-picker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CustomDateTimePickerComponent),
            multi: true
        }
    ]
})
export class CustomDateTimePickerComponent implements OnInit {
    @ViewChild('errorPopover', { static: true }) errorPopover: PopoverDirective;
    @Input() pickerConfig: Partial<BsDatepickerConfig>;
    @Input() inputPlaceholder: string;
    @Input() isDisabled: boolean;
    @Input() isFormControl: boolean;
    @Input() formSubmitted: boolean;
    @Input() isDateRange = false;
    @Input() hasErrorMessage: boolean;
    @Input() isStart: boolean;
    @Input() isEnd: boolean;
    @Input() automationId = '';

    pickerError: string;
    inputFocused: boolean;
    showClearButton: boolean;
    dateValue: Date;

    private defaultConfig: Partial<BsDatepickerConfig>;
    private propagateChange = (_: any) => {
        return;
    };

    ngOnInit(): void {
        if (!this.pickerConfig) {
            this.defaultConfig = new BsDatepickerConfig();
            this.defaultConfig.showWeekNumbers = false;
            this.defaultConfig.dateInputFormat = 'YYYY-MM-DD';
            this.defaultConfig.customTodayClass = 'custom-today-class';
            this.pickerConfig = this.defaultConfig;
        }
    }

    writeValue(value: Date): void {
        this.dateValue = value;
        if (!this.dateValue && this.showClearButton) {
            this.showClearButton = false;
        }
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        return;
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    onDateChange(): void {
        this.propagateChange(this.dateValue);
        this.showClearButton = this.dateValue ? true : false;

        if (this.isDateRange && this.hasErrorMessage && this.dateValue) {
            if (this.isStart) {
                this.pickerError = 'Start Date should be before end date';
            } else {
                this.pickerError = 'End Date should be after start date';
            }
            this.errorPopover.show();
        } else {
            this.errorPopover.hide();
        }
    }

    onClearClick(): void {
        this.dateValue = null;
        this.onDateChange();
        this.showClearButton = false;
        this.formSubmitted = false;
        this.errorPopover.show();
    }

    clearErrorPopover(): void {
        this.errorPopover.hide();
    }

    // set/remove focus class to/from control if input control is focused/unfocused
    onPickerInputFocus(isFocused: boolean): void {
        this.inputFocused = isFocused;
        this.errorPopover.hide();
    }

    onInput(event: any): void {
        if (event && event.target && event.target.value && event.target.value !== '') {
            this.showClearButton = true;
        } else {
            this.showClearButton = false;
        }
    }
}
